import { Text, Flex, Spinner, Card } from '@applyboard/crystal-ui';

import { useReportsResult } from '../context';
import { default as WarningIcon } from './charts/assets/warning-icon.svg';
import { PieChart } from './charts/PieChart';
import { ChartLegend } from './charts/ChartLegend';

export function ApplicationStats() {
  const { stats, totalApplications, isLoadingStats, isFetchingStats } = useReportsResult();

  if (isLoadingStats || isFetchingStats) {
    return (
      <Flex grow={1} px={5} py={24} gap={5} align="center" direction="column" role="progressbar">
        <Spinner size="xl" />
      </Flex>
    );
  }

  return (
    <Flex gap={10} direction="column" basis="100%">
      <Flex direction="column">
        <Text variant="titleM">Application volumes</Text>
        <Text variant="bodyS" intent="secondary">
          This data shows how the total application volume is distributed across different states.
        </Text>
      </Flex>

      {stats && totalApplications > 0 && (
        <Card>
          <Flex gap={10} p={2}>
            <Flex.Item basis={400} shrink={0}>
              <ChartLegend stats={stats} totalApplications={totalApplications} />
            </Flex.Item>
            <Flex.Item grow={1}>
              <PieChart stats={stats} />
            </Flex.Item>
          </Flex>
        </Card>
      )}

      {(!stats || totalApplications === 0) && (
        <Flex justify="center" direction="column" align="center" pt={20}>
          <img src={WarningIcon} width="112.96px" height="112.31px" alt="No Data Available to Display" />
          <Text intent="secondary" variant="titleM">
            No Data Available to Display
          </Text>
          <Text intent="secondary" variant="bodyM">
            Please make a selection in the above fields to generate results
          </Text>
        </Flex>
      )}
    </Flex>
  );
}
